module.exports = __webpack_public_path__ + "img/img15.7e010e36.png";